import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthenticationGuard } from 'src/core-modules/authentication/authentication.guard';
import { ShowMenuGuard } from 'src/core-modules/show-menu/showMenu.guard';
import { CustomersComponent } from './customers/customers.component';
import { EmployeesComponent } from './employees/employees.component';
import { RolesComponent } from './roles/roles.component';
import { RoleLevelsComponent } from './role-levels/role-levels.component';

const routes: Routes = [
  {
    path: '',
    canActivate: [AuthenticationGuard],
    children: [
      {
        path: '',
        redirectTo: 'customers',
        pathMatch: "full"
      },
      {
        path: 'customers',
        component: CustomersComponent,
        data: { submenu: "customers" },
        canActivate: [ShowMenuGuard]
      },
      {
        path: 'employees',
        component: EmployeesComponent,
        data: { submenu: "employees" },
        canActivate: [ShowMenuGuard]
      },
      {
        path: 'roles',
        component: RolesComponent,
        data: { submenu: "roles" },
        canActivate: [ShowMenuGuard]
      },
      {
        path: 'role-levels',
        component: RoleLevelsComponent,
        data: { submenu: "role-levels" },
        canActivate: [ShowMenuGuard]
      }
    ]
  }

];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class AdministrationRoutingModule { }
